export default "__VITE_ASSET__CxBRrjc9__"